import jsPDF from 'jspdf';
import 'jspdf-autotable';
import pdfIcon from '../assets/img/fileTypes/pdf.svg';

const exportPdf = ({ filename, data, headers, theme = 'striped', dataType = 'json' }) => {
    const doc = new jsPDF();

    if (dataType === 'json') {
        let customHeader = [];

        if (!headers) {
            for (let x in data[0]) {
                customHeader.push({ header: x.charAt(0).toUpperCase() + x.slice(1), dataKey: x })
            }
        }

        // Convert object to PDF
        doc.autoTable({
            columns: headers || customHeader, //[{header: 'Name', dataKey: 'name'}]
            body: data,
            theme
        });
        doc.save(filename + '.pdf');
    } else {
        // convert Table to PDF
        doc.autoTable({
            html: data,
            theme
        });
        doc.save(filename + '.pdf');
    }

}

export { pdfIcon, exportPdf as default };